import type { ModalInstance } from '../../../contexts/ModalContext';
import type {
  ContentObject,
  ContentTypeDefinition,
} from '../../flotiq-client/types/api-response';

import { IFlotiqPluginEvent } from './IFlotiqPluginEvent';

/**
 * Callback to update plugin settings.
 *
 * @memberof FlotiqPlugins.Events
 */
type UpdateSettings = (settings: object) => Promise<[ContentObject, object]>;

type PluginsManageEventInit = {
  /** Plugin data */
  plugin: ContentObject;
  /** Callback for reloading plugin settings */
  reload: () => void;
  /** Settings modal instance with resolve method */
  modalInstance: ModalInstance;
  /** Content types data */
  contentTypes: ContentTypeDefinition[];
  /**
   * Callback to update plugin settings.
   * Returns a tuple with new settings (first element) and possible errors (second element).
   */
  updateSettings: UpdateSettings;
};

/**
 * An event that is fired on manage button click.
 * Returning object will be used to render manage modal content.
 * A plugin will not receive this event when manage button is clicked for any other plugin.
 *
 * @eventName "flotiq.plugins.manage::render"
 * @memberof FlotiqPlugins.Events
 * @returns {null|string|array|number|boolean|HTMLElement|ReactElement}
 */
export class PluginsManageEvent extends IFlotiqPluginEvent {
  constructor(initData: PluginsManageEventInit) {
    super(initData);
  }
}
